"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Truncates the result set based on `maxResults` and returns the new set.
 */
function getTruncatedOptions(options, maxResults) {
  if (!maxResults || maxResults >= options.length) {
    return options;
  }

  return options.slice(0, maxResults);
}

exports.default = getTruncatedOptions;


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-typeahead/lib/utils/getTruncatedOptions.js
// module id = 1133
// module chunks = 0